import { Pipe, PipeTransform } from "@angular/core";
import * as _ from 'lodash';
import { DateService } from "../services/date.service";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({ name: "dateFormat" })
export class DatePipe implements PipeTransform {

   constructor(private dateService: DateService, public translateService: TranslateService) { }

   /*transform(date,format = "DD/MM/YYYY",textWithTime = false) {
        return this.dateService.formatDate(date,format,textWithTime);
    }*/


   transform(date, textWithTime, nearDate) {
      const language = this.translateService.currentLang;
      if (language && language?.toUpperCase() == "EN") {
         let observable: Observable<any> = this.dateService.formatDate(date, "MM/DD/YYYY", textWithTime, nearDate);
         return observable.pipe(map(res => {
            return res;
         }));

      }
      else {
         let observable: Observable<any> = this.dateService.formatDate(date, "DD/MM/YYYY", textWithTime, nearDate);
         return observable.pipe(map(res => {
            return res;
         }));
      }
   }
}
